import {
  type JSX,
  createContext,
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  useContext,
  useMemo,
  useState,
} from 'react';

type Context = {
  hoveredResultIndex: number | null;
  setHoveredResultIndex: Dispatch<SetStateAction<number | null>>;
};

const defaultContext: Context = {
  hoveredResultIndex: null,
  setHoveredResultIndex: () => {},
};

const SearchUIContext = createContext<Context>(defaultContext);

export const SearchUIContextProvider = ({ children }: PropsWithChildren): JSX.Element => {
  const [hoveredResultIndex, setHoveredResultIndex] = useState<number | null>(null);

  const contextValue = useMemo(
    () => ({
      hoveredResultIndex,
      setHoveredResultIndex,
    }),
    [hoveredResultIndex]
  );

  return <SearchUIContext.Provider value={contextValue}>{children}</SearchUIContext.Provider>;
};

export const useSearchUIContext = (): Context => {
  const context = useContext(SearchUIContext);
  if (!context) {
    throw new Error('useSearchUIContext must be used within a SearchUIProvider');
  }

  return context;
};
